import React from "react";

interface StatCardProps {
    icon: React.ElementType;
    value: string;
    label: string;
    className?: string;
}

export default function StatCard({ icon: Icon, value, label, className }: StatCardProps) {
    return (
        <div
            className={[
                "rounded-2xl bg-white p-6 md:min-w-[240px] border border-border-subtle shadow-sm transition-all duration-300 ease-out hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/20",
                className
            ].join(" ")}
        >
            {/* Icon */}
            <div className="text-primary">
                <Icon className="h-5 w-5" />
            </div>

            {/* Value */}
            <div className="mt-4 text-2xl lg:text-5xl md:text-6xl font-extrabold tracking-tight bg-brand-gradient bg-clip-text text-transparent">
                {value}
            </div>

            {/* Label */}
            <p className="mt-2 text-base md:text-lg tracking-tight text-text-muted">{label}</p>
        </div>
    );
}
